// tslint:disable
import { BaseAvroRecord } from "../../BaseAvroRecord";

export interface UserInterface {
    visitorCookieId?: null | string;
    userId?: null | number;
    subscriptionId?: null | number;
    organizationId?: null | number;
}

export class User extends BaseAvroRecord implements UserInterface {

    public visitorCookieId?: null | string;
    public userId?: null | number;
    public subscriptionId?: null | number;
    public organizationId?: null | number = null;

    public static readonly subject: string = "user";
    public static readonly schema: object = {
    "type": "record",
    "name": "User",
    "namespace": "storyblocks.common",
    "fields": [
        {
            "name": "visitorCookieId",
            "type": [
                "null",
                "string"
            ]
        },
        {
            "name": "userId",
            "type": [
                "null",
                "int"
            ]
        },
        {
            "name": "subscriptionId",
            "type": [
                "null",
                "int"
            ]
        },
        {
            "name": "organizationId",
            "type": [
                "null",
                "int"
            ],
            "default": null
        }
    ]
}

    public schema(): object {
        return User.schema;
    }

    public subject(): string {
        return User.subject;
    }
}
